import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Tile} from '../../models/tile.model';
import {CommonModule} from '@angular/common';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'tile-card',
  templateUrl: './tile-card.component.html',
  styleUrls: ['./tile-card.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink]
})
export class TileCardComponent {
  @Input({required: true}) tile!: Tile;
  @Output() openExternal = new EventEmitter<string>();

  onClick() {
    if (this.tile.externalUrl) this.openExternal.emit(this.tile.externalUrl);
  }
}
